function showNotices() {
  // Cookiebot blocks iframes by moving src to data-cookieblock-src and setting display:none
  const blockedIframes = document.querySelectorAll('iframe[data-cookieblock-src]');

  blockedIframes.forEach((iframe) => {
    // Prefer the Gutenberg embed wrapper (already position:relative), fall back to parent
    const wrapper = iframe.closest('.wp-block-embed__wrapper');
    const container = wrapper || iframe.parentElement;

    if (container.querySelector('.iframe-cookie-notice')) return;

    // For iframes not inside a positioned wrapper, add one
    if (!wrapper) {
      const div = document.createElement('div');
      div.className = 'iframe-cookie-notice-wrap';
      iframe.parentNode.insertBefore(div, iframe);
      div.appendChild(iframe);
    }

    const notice = document.createElement('div');
    notice.className = 'iframe-cookie-notice';
    notice.innerHTML = `
      <p class="iframe-cookie-notice__text">Det här innehållet kräver att du accepterar cookies.</p>
      <button class="iframe-cookie-notice__btn">Hantera cookie-inställningar</button>
    `;

    notice.querySelector('.iframe-cookie-notice__btn').addEventListener('click', () => {
      if (!window.Cookiebot) return;
      // Cookiebot's show()/renew() won't reopen after a decline in the same session.
      // Clearing the consent cookie resets its internal state so show() works again.
      document.cookie = 'CookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      window.location.reload();
    });

    container.appendChild(notice);
  });
}

function removeNotices() {
  document.querySelectorAll('.iframe-cookie-notice').forEach((el) => el.remove());

  // Unwrap any iframes we wrapped
  document.querySelectorAll('.iframe-cookie-notice-wrap').forEach((wrap) => {
    const iframe = wrap.querySelector('iframe[data-cookieblock-src]');
    if (iframe) wrap.parentNode.insertBefore(iframe, wrap);
    wrap.remove();
  });
}

export default function() {
  window.addEventListener('CookiebotOnDialogDisplay', showNotices);
  window.addEventListener('CookiebotOnLoad', showNotices);
  window.addEventListener('CookiebotOnDecline', showNotices);
  window.addEventListener('CookiebotOnAccept', removeNotices);

  // Cookiebot fires its events from the <head>, before footer scripts load.
  // Call directly in case the event already fired before our listener was registered.
  showNotices();
}



// WEBPACK FOOTER //
// ./scripts/components/iframe-cookie-notice.js